"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPageTranslationKey = void 0;
let ErrorPageTranslationKey = exports.ErrorPageTranslationKey = /*#__PURE__*/function (ErrorPageTranslationKey) {
  ErrorPageTranslationKey["buttonText"] = "buttonText";
  ErrorPageTranslationKey["contactSupportTeam"] = "contactSupportTeam";
  ErrorPageTranslationKey["headline"] = "headline";
  ErrorPageTranslationKey["notFound"] = "notfound";
  ErrorPageTranslationKey["rejectedUrl"] = "rejectedUrl";
  ErrorPageTranslationKey["text"] = "text";
  ErrorPageTranslationKey["unauthorized"] = "unauthorized";
  return ErrorPageTranslationKey;
}({});
